export default {
  ITEM: 1,
  PAYMENT: 2,
  CATEGORY: 3,
}



// WEBPACK FOOTER //
// ./src/consts/reportAggregateTargets.js